import { CenterActivity } from '../../../lib/types/models/center-activity/center-activity'
import { CenterActivityInput } from '../../../lib/types/models/center-activity/center-activity-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateCenterActivity = async (
  data: UpdateInput<CenterActivityInput> & { centerId: number }
) => {
  const { id, centerId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterActivity.url, { centerId, centerActivityId: id }))
    .patch<CenterActivity, Partial<CenterActivityInput>>(rest)
}
